import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationsService } from './services/configurations.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ConfigurationsService],
})
export class ConfigurationsModule {}
